// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"77414900","444":"18af85f7","535":"6e878463","706":"9212f5c4","787":"28cb0dcd","844":"9cf30d01"}[chunkId] + ".chunk.js";
};